<template>
  <div class="bloc-image" v-if="content" :style="{maxWidth: content.max_width + 'px'}">
    <a :href="getSrc(content.optimize)">
      <img loading="lazy" :src="getSrc(content.optimize)" :alt="content.alt" :title="content.title">
    </a>
  </div>
</template>

<script>
import SimpleLightbox from "simplelightbox";
import "simplelightbox/dist/simple-lightbox.min.css";
import imgOpti from "@/mixins/imgOpti.js";
export default {
  mixins: [imgOpti],
  props: {
    content: null
  },
  mounted() {
    const lightbox = new SimpleLightbox('.bloc-image a', { 
      heightRatio: 1,
      widthRatio: 1,
      loop: false,
      fileExt: false
     });
  },
  methods: {
    getWidth() {
      if(window.innerWidth < 1000) {
        return 1000;
      }
      return window.innerWidth;
    },
    getSrc(o) {
      return o
        ? this.content.img
        : this.optimize(this.content.img, this.getWidth());
    }
  }
};
</script>

<style lang="scss">
.bloc-image {
  width: 100%;
  max-width: 80%;
  margin: auto;
  img {
    max-width: 80%;
    margin: auto;
  }
}
@media screen and (max-width: $desktop) {
  .bloc-image {
    max-width: 100%;
    img {
      max-width: 100%;
    }
  }
}
</style>
